<template>
  <v-dialog v-model="dialog" persistent max-width="680">
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <v-card v-if="product">
        <v-app-bar flat color="primary">
          <v-avatar v-if="product.image" tile size="40" class="mr-3 rounded" color="white">
            <v-img :src="getPathProduct(product)"></v-img>
          </v-avatar>
          <v-toolbar-title class="text-h6 white--text pl-0">
            {{ product.name }}
            <v-chip color="default" filter label>{{ product.reference }}</v-chip>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="$emit('cancel')" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text style="max-height: 60vh; overflow-y: auto">
          <div class="fila-precio mt-2">
            <ng-select-options v-if="$pos && $pos.priceLists" v-model="currentPriceList" :items="$pos.priceLists"
              @change="changePriceList" :clearable="false" :flat="false" :filled="false" dense :outlined="true"
              :full-width="true"></ng-select-options>

            <v-select v-model="discount" :items="discountRates" :label="$t('discounts')" @change="changePriceList"
              dense outlined>
            </v-select>
          </div>

          <div class="cantidad-caja">
            <ng-number-keyboard v-model="quantity" :label="$t('quantity')" rules="required" :filled="false" dense
              show-required="true" id="quantity-field"></ng-number-keyboard>
            <v-btn icon outlined class="mx-2" @click="minus" :title="$t('decrease')">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-btn icon outlined color="primary" @click="quantity++" :title="$t('increase')">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>

          <div class="lotes-titulo">Elige el lote</div>

          <template v-if="!variantsBatch">
            <template v-if="batchItems && batchItems.length > 0">
              <div v-for="itemBatch in batchItems" :key="itemBatch.id" class="lote" :class="claseVence(itemBatch)">
                <div class="lote__datos">
                  <div class="lote__nombre"><v-icon small>mdi-barcode</v-icon> {{ $t('Lote') }} {{ itemBatch.batch }}</div>
                  <div class="lote__vence">
                    {{ $t('Vence en') }}: {{ itemBatch.expiration_date }}
                    <span v-if="textoVence(itemBatch)" class="lote__aviso">{{ textoVence(itemBatch) }}</span>
                  </div>
                </div>
                <div class="lote__existencias">
                  <strong>{{ itemBatch.quantity }}</strong>
                  <span>{{ $t('Existencias') }}</span>
                </div>
                <v-btn color="success" depressed :disabled="invalid || estaVencido(itemBatch)" @click="addItem(itemBatch)">
                  <v-icon left>{{ estaVencido(itemBatch) ? "mdi-block-helper" : "mdi-check" }}</v-icon>{{ estaVencido(itemBatch) ? "Vencido" : "Seleccionar" }}
                </v-btn>
              </div>
            </template>
            <v-alert v-else text color="secondary">
              Este producto no tiene inventario, generar una compra o hacer el ajuste desde gestion de inventario.
            </v-alert>
          </template>
          <template v-else>
            <template v-for="itemBatch in batchItems">
              <div v-for="(vr, index) in variantsBatch[itemBatch.id]" :key="'div' + itemBatch.id + '-' + index"
                class="lote lote--variantes" :class="claseVence(itemBatch)">
                <div class="lote__fila">
                  <div class="lote__datos">
                    <div class="lote__nombre"><v-icon small>mdi-barcode</v-icon> {{ $t('Lote') }} {{ itemBatch.batch }}</div>
                    <div class="lote__vence">
                      {{ $t('Vence en') }}: {{ itemBatch.expiration_date }}
                      <span v-if="textoVence(itemBatch)" class="lote__aviso">{{ textoVence(itemBatch) }}</span>
                    </div>
                  </div>
                  <div class="lote__existencias">
                    <strong>{{ itemBatch.quantity }}</strong>
                    <span>{{ $t('Existencias') }}</span>
                  </div>
                </div>
                <div class="lote__variantes">
                  <v-btn v-for="(opt, i) in vr.options" :key="i" color="primary" depressed class="lote__pres-btn"
                    :disabled="invalid || estaVencido(itemBatch) || !alcanza(itemBatch, opt)" @click="selectVariant(opt, vr, itemBatch)">
                    <span class="lote__pres">
                      <span class="lote__pres-nombre">{{ opt.name }}</span>
                      <small>{{ estaVencido(itemBatch) ? "Lote vencido" : alcanza(itemBatch, opt) ? $filters.currency(getPriceItem(opt.id)) : "No alcanza en este lote" }}</small>
                    </span>
                  </v-btn>
                </div>
              </div>
            </template>
          </template>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text large @click="$emit('cancel')">{{ $t("Cancel") }}</v-btn>
        </v-card-actions>

       

        <!--v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark outlined color="primary" @click="$emit('cancel')" :title="$t('Cancel')">
            {{ $t("Cancel") }}
          </v-btn>
          <v-btn color="primary" @click="update" :disabled="invalid" :title="$t('accept')">
            {{ $t("accept") }}
          </v-btn>
        </v-card-actions-->
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<style scoped>
.fila-precio {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cantidad-caja {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.cantidad-caja > .v-btn {
  margin-top: 4px;
}

.lotes-titulo {
  margin: 4px 0 8px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
}

.lote {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-left: 5px solid #43a047;
  border-radius: 10px;
  background: #fff;
}

.lote--variantes {
  flex-direction: column;
  align-items: stretch;
}

.lote__fila {
  display: flex;
  align-items: center;
  gap: 12px;
}

.lote__datos {
  flex: 1 1 auto;
  min-width: 0;
}

.lote__nombre {
  font-size: 1.05rem;
  font-weight: 700;
}

.lote__vence {
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.7);
}

.lote__aviso {
  margin-left: 6px;
  font-weight: 700;
}

.lote__existencias {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
  line-height: 1.1;
}

.lote__existencias strong {
  font-size: 1.3rem;
}

.lote__existencias span {
  font-size: 0.72rem;
  color: rgba(0, 0, 0, 0.6);
}

.lote__variantes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.lote__pres-btn {
  height: auto !important;
  min-height: 52px;
  padding: 6px 14px !important;
  text-transform: none;
  letter-spacing: 0;
}

.lote__pres {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}

.lote__pres-nombre {
  font-weight: 700;
  text-transform: capitalize;
}

.lote__pres small {
  font-size: 0.8rem;
  opacity: 0.95;
}

.lote--por-vencer {
  border-left-color: #fb8c00;
  background: #fff8e1;
}

.lote--por-vencer .lote__aviso {
  color: #e65100;
}

.lote--vencido {
  border-left-color: #e53935;
  background: #fff5f5;
}

.lote--vencido .lote__aviso {
  color: #c62828;
}
</style>
<script>
import CartSectionProductSaleOptions from "./CartSectionProductSaleOptions";
export default {
  name: "CartSectionProductBatchDetail",
  components: { CartSectionProductSaleOptions },
  props: ["itemLine", "currentProduct", "open", "dialog", "priceList"],
  data: () => ({
    //prices: null
    //isVisible: false
    discountRates: [
      0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
      95,100
    ],
    discount: 0,
    quantity: 1,
    options: null,
    optionsItem: {},
    variants: null,
    variantsBatch: null,
    variantsItem: {},
    variant: null,
    productVariant: null,
    key: 0,
    note: "",
    product: null,
    price: 0,
    currentPriceList: null,
    changePriceListFromForm: false,
    priceIsChange: false,
    cashRegister: null,
    enablePriceChange: false,
    batchItems: [

    ]
  }),
  watch: {
    'dialog': {
      deep: true,
      immediate: true,
      handler() {
        console.log(this.dialog);
        if (this.dialog) {
          //  setTimeout(() => {
          this.loadBatch();
          //  }, 1000)
        }
      },
    }
  },
  async mounted() {
    this.clean();
    await this.loadConfig();


    if (this.priceList) {
      this.currentPriceList = {
        id: this.priceList.id,
        name: this.priceList.name,
      };
    }
    if (this.itemLine && this.itemLine.price_list_id) {
      for (const priceList of this.$pos.priceLists) {
        if (this.itemLine.price_list_id == priceList.id) {
          this.currentPriceList = { id: priceList.id, name: priceList.name };
          break;
        }
      }
    }
    if (this.itemLine) {
      if (this.itemLine.percentage_discount) {
        this.discount = this.itemLine.percentage_discount;
      }
      if (this.itemLine.unit_price) {
        this.price = this.itemLine.unit_price;
      }
    } else {
      if (this.product) {
        this.getProductPrice();
      }
    }
    this.setCashRegister();
  },

  methods: {
    getPriceItem(optionId) {
      let productId = null;
      if (this.currentProduct) {
        productId = this.currentProduct.id;
      }else{
        productId = this.itemLine.product.id
      }
      let product = this.$db.getProduct(productId);
      let prodVariant = this.$db.searchVariant(this.product.id, [optionId]);

      return this.$pos.getSalePrice(
            this.product,
            this.discount,
            this.getPriceListId(),
            prodVariant.id
          );

    },
    // Unidades que se descuentan del lote al vender esta presentación (la caja de 100 pesa 100); 0 = no se sabe.
    factorDe(opt) {
      const pv = this.$db.searchVariant((this.currentProduct || this.itemLine.product).id, [opt.id]);
      const f = pv ? parseFloat(pv.conversion_factor) : 0;
      return f > 0 ? (f > 1 ? f : 1) : 0;
    },
    alcanza(lote, opt) {
      const factor = this.factorDe(opt);
      if (!factor) return true;
      return (parseFloat(this.quantity) || 0) * factor <= (parseFloat(lote.quantity) || 0);
    },
    // Días que faltan para que venza el lote (negativo si ya venció); null si no trae fecha.
    diasParaVencer(lote) {
      if (!lote || !lote.expiration_date) return null;
      const t = Date.parse(String(lote.expiration_date).substring(0, 10) + "T23:59:59");
      if (isNaN(t)) return null;
      return Math.floor((t - Date.now()) / 86400000);
    },
    // Un lote vencido no se vende: el cajero no puede elegirlo.
    estaVencido(lote) {
      const d = this.diasParaVencer(lote);
      return d !== null && d < 0;
    },
    claseVence(lote) {
      const d = this.diasParaVencer(lote);
      if (d === null) return "";
      if (d < 0) return "lote--vencido";
      return d <= 90 ? "lote--por-vencer" : "";
    },
    textoVence(lote) {
      const d = this.diasParaVencer(lote);
      if (d === null) return "";
      if (d < 0) return "Vencido";
      if (d === 0) return "Vence hoy";
      return d <= 90 ? "Vence en " + d + (d === 1 ? " día" : " días") : "";
    },
    selectVariant(opt, vr, batch) {

//console.log(batch, '......................2')
      this.$nextTick(() => {
        this.variantsItem = batch.batch; // + '-' + opt.id;

        const options = [opt.id];
        let product_id = null;
        if (this.itemLine) {
          product_id = this.itemLine.product.id
        } else {
          product_id = this.currentProduct.id
        }

        this.productVariant = this.$db.searchVariant(product_id, options);
        this.update();
      })



    },
    loadBatch() {
      let installation = this.$store.getters.installation;
      if (!installation) return;

      let productId = null;
      if (this.currentProduct) {
        productId = this.currentProduct.id;
      }
      if (this.itemLine) {
        productId = this.itemLine.product.id
      }

      this.$http.get("api/v1/stock-batch", { product: [productId], active: true, subsidiary: [installation.subsidiary_id] }, true).then((response) => {
        if (response.items.length > 0) {
          this.batchItems = response.items;
          if (this.variants) {
            this.variantsBatch = {};
            for (const item of this.batchItems) {
              this.variantsBatch[item.id] = Object.assign({}, this.variants);
            }
          }
        }
      })
    },

    getProductPrice() {
      if (this.itemLine && !this.changePriceListFromForm) {
        this.price = this.$pos.getSalePrice(
          this.product,
          this.discount,
          this.getPriceListId(),
          this.productVariant?.id
        );
        if (this.discount) {
          return this.$pos.getSalePrice(
            this.product,
            this.discount,
            this.getPriceListId(),
            this.productVariant?.id
          );
        } else {
          return this.price;
        }
      } else {
        this.price = this.$pos.getSalePrice(
          this.product,
          this.discount,
          this.getPriceListId(),
          this.productVariant?.id
        );
        return this.price; //this.$pos.getSalePrice(this.product, this.discount, this.getPriceListId())
      }
    },
    changePriceList() {
      this.changePriceListFromForm = true;
      if (this.currentPriceList) {
        //return this.currentPriceList.id
        this.price = this.$pos.getSalePrice(
          this.product,
          0,
          this.getPriceListId(),
          this.productVariant?.id
        );
      }
    },
    getPriceListId() {
      if (this.currentPriceList) {
        return this.currentPriceList.id;
      }
      return null;
    },
    clean() {
      this.key++;
      this.product = this.currentProduct;
      this.variants = null;
      this.variantsItem = null;
      this.variant = null;
      this.options = null;
      this.optionsItem = {};
      this.note = "";
      this.loadConfig();
      this.priceIsChange = false;
      this.key++;
    },
    minus() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },



    async loadConfig() {
      if (this.itemLine) {
        this.quantity = this.itemLine.quantity;
        this.product = await this.$db.getProduct(this.itemLine.product.id);
        this.note = this.itemLine.note;
      }

      if (this.product.type == "variant") {
        await this.loadVariants();
      }

    },

    addItem(itemBatch){
      this.variantsItem = itemBatch.batch ;
      this.update();
    },
    async update() {

      console.log( this.itemLine, 'iteldoct');

      //console.log(this.productVariant, "update product detail....");
      let opts = {
        itemLine: this.itemLine,
        variant: this.productVariant,
        quantity: this.quantity,
        note: this.note,
        options: this.optionsItem,
        discount: this.discount,
        new_price: -1,
        bill_price_list_id: this.currentPriceList.id,
      };
      if (this.priceIsChange) {
        opts.new_price = this.price;
      } else {
        let price = this.$pos.getSalePrice(
          this.product,
          0,
          this.getPriceListId(),
          this.productVariant?.id
        );
        opts.new_price = price;
      }
      if (this.variantsItem) {
        // let parts = this.variantsItem.split('-');
        // opts.batch = parts[0];
        opts.batch = this.variantsItem;
        this.variantsItem = '';
      }
      if(this.itemLine && this.itemLine.data_doctor){
        opts.data_doctor = this.itemLine.data_doctor;
      }
      this.$emit("selectedOptions", opts);
    },
    getPathProduct(item) {
      if (item) {
        return this.$http.getBaseUrlImagesProducts() + item.image;
      }
      return "@/assets/product-blank.png";
    },
    getProductsByCategory(catId) {
      const prds = this.$db.searchProducts(
        {
          category_id: { $eq: catId },
        },
        30,
        "name"
      );
      return prds;
    },

    changePrice() {
      this.priceIsChange = true;
    },
    async loadVariants() {
      let allVariants = await this.$db.getVariants();

      const variantsProduct = [];
      this.variantsItem = null; //variantes seleccionadas
      let currentVariant = null;
      if (
        this.itemLine &&
        this.itemLine.product_variant &&
        this.itemLine.product_variant.id
      ) {
        currentVariant = await this.$db.getProductVariants(
          this.itemLine.product_variant.id
        );
      }
      // se optienen la informacion de las opciones posibles configuradas para el producto de cada variante
      // si itemLine esta seteado se preseleccionan las opciones de variantes correspondientes
      for (const v of this.product.variants.variants) {
        for (const variant of allVariants) {
          if (v.id == variant.id) {
            const options = [];
            for (const opt of this.product.variants["v-" + v.id]) {
              const idx = variant.options.findIndex((o) => o.id == opt.id);
              if (idx >= 0) {
                const option = variant.options[idx];
                option.selected = false;

                if (
                  currentVariant &&
                  currentVariant.inv_variant_option_ids &&
                  currentVariant.inv_variant_option_ids.indexOf(opt.id) >= 0
                ) {
                  option.selected = true;
                  //this.variantsItem[v.id] = opt.id;
                }
                options.push(option);
                if (currentVariant && currentVariant.length > 0) {
                  /*for (const vari of currentVariant) {
                    if (
                      vari &&
                      vari.inv_variant_option_ids &&
                      vari.inv_variant_option_ids.indexOf(opt) >= 0
                    ) {
                      this.variantsItem[v.id] = opt;
                    }
                  }*/
                }
              }
            }
            variantsProduct.push({
              id: variant.id,
              name: variant.name,
              is_colour: variant.is_colour,
              options: options.sort(function (a, b) {
                return (a.order || 0) - (b.order || 0) || a.name.localeCompare(b.name);
              }),
            });
          }
        }
      }
      this.variants = variantsProduct.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.key++;
    },
    async setCashRegister() {
      let installation = this.$store.getters.installation;

      if (installation && !this.cashRegister) {
        this.cashRegister = await this.$db.getCashRegister(
          installation.cash_id
        );
      }

      this.viewPriceChange();
    },
    async viewPriceChange() {
      this.enablePriceChange = false;
      if (this.cashRegister) {
        if (this.cashRegister.config) {
          if (
            this.cashRegister.config.pos_active_price_change &&
            this.itemLine
          ) {
            this.enablePriceChange =
              this.cashRegister.config.pos_active_price_change;
          }
        }
      }
    },
  },
};
</script>